import { Injectable } from '@angular/core';
import { AppState, JobDateEquipTimecardFacadeBase } from '@app/state';
import { Store } from '@ngrx/store';
import { JobDateEquipTimecard } from '@app/models';

@Injectable({ providedIn: 'root' })
export class JobDateEquipTimecardFacade extends JobDateEquipTimecardFacadeBase {
  constructor(private store: Store<AppState>) {
    super(JobDateEquipTimecard, store);
  }
}
